// extracted by mini-css-extract-plugin
export default {"input":"Input__input___HT5nz","right":"Input__right___JJtOt"};